var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDataFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 31.9032V18.8284L39.1662 31.7723H38.7761V18.8278L23.9423 31.7723V4.5765C23.9423 2.35373 18.8676 0 12.231 0C5.5944 0 0 2.22278 0 4.5765V54H23.6817H54V31.9032ZM12.231 6.79928C7.4169 6.79928 3.51338 5.62275 3.51338 4.31528C3.51338 3.0078 7.4169 1.83128 12.2317 1.83128C17.0465 1.83128 20.95 2.87753 20.95 4.31528C20.95 5.62275 17.0465 6.79928 12.2317 6.79928H12.231ZM37.7345 45.3708H31.7493V39.3566H37.7352V45.3708H37.7345ZM27.3247 45.3708H21.3388V39.3566H27.3247V45.3708ZM42.419 45.3708V39.3566H48.4043V45.3708H42.419Z",
    fill: "url(#paint0_linear_567_1597)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_1597",
    x1: 27,
    y1: 0,
    x2: 27,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E35EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#922998"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataFactory);
export default __webpack_public_path__ + "static/media/data-factory.f4ef219808e70dc2a7bd5f7e1db8d6a6.svg";
export { ForwardRef as ReactComponent };